import { FOOD } from "@/data/media";

// Editorial menu. Categories carry dishes; typography carries the ones without images.
export const MENU = [
  {
    id: "house-snacks",
    title: "House Snacks",
    dishes: [
      { name: "Kerala Snack Selection", desc: "Crisp plantain chips, murukku and jaggery-glazed banana bites." },
      { name: "Pappad Basket", desc: "Crisp lentil wafers with gooseberry chutney, mint yoghurt and jaggery ginger chutney." },
    ],
  },
  {
    id: "small-plates",
    title: "Small Plates",
    dishes: [
      { name: "Green Garden Chaat", desc: "Kale, spinach and spring onions with yoghurt, tamarind and chaat spices." },
      { name: "Old Delhi Samosa Chaat", desc: "Crushed samosa, chickpeas, yoghurt and sweet tamarind." },
      { name: "Bombay Onion Bhaji Chaat", desc: "Crisp onion fritters with yoghurt and vibrant house chutneys." },
      { name: "CST Crispy Okra", desc: "Lightly fried okra with a sweet, tangy chilli glaze." },
    ],
  },
  {
    id: "from-tandoor",
    title: "From Tandoor",
    dishes: [
      { name: "Mysore Sandalwood Chicken Tikka", desc: "Charcoal-grilled chicken with aromatic southern spices." },
      { name: "Wild Kanthari Chilli Chicken Chops", desc: "Chicken chops in a fiery Kerala bird's-eye chilli marinade." },
      { name: "Royal Awadhi Lamb Sheekh", desc: "Hand-minced lamb skewers with herbs and warming spices." },
      { name: "Himalayan Spiced Lamb Cutlets", desc: "Charred lamb chops seasoned with fragrant tandoori spices.", image: FOOD.tandoorLamb, featured: true },
      { name: "Malabar Curry Leaf Monkfish Tikka", desc: "Roasted monkfish with a fragrant curry leaf marinade." },
      { name: "Ajwain Malai Tandoori Prawns", desc: "King prawns in a delicate malai and ajwain marinade." },
      { name: "Black Pepper Paneer Tikka", desc: "Tandoor-roasted paneer with mango and mint gel." },
      { name: "Broccoli Malai Roast", desc: "Charred broccoli florets in a coconut cream marinade with rose petal & almond." },
    ],
  },
  {
    id: "coastal",
    title: "Coastal Specialties",
    dishes: [
      { name: "Varkkala Harbour Sardine Tawa Roast", desc: "Pan-roasted sardines with chilli, turmeric and coastal spices." },
      { name: "Seared Malabar Coast Scallops", desc: "Seared scallops with fragrant coastal spices and a delicate finish.", image: FOOD.scallops, featured: true },
      { name: "Kuttanad Backwater Prawn Curry", desc: "Juicy prawns simmered in a rich coastal coconut gravy." },
      { name: "Malabar King Fish Curry", desc: "King fish in a tangy coconut coastal gravy." },
      { name: "Kottayam Fish Curry", desc: "Spicy red chilli fish curry with tamarind.", image: FOOD.fishCurry, featured: true },
    ],
  },
  {
    id: "signature-curries",
    title: "Signature Curries",
    dishes: [
      { name: "Alleppey Coastal Chicken Curry", desc: "Tender chicken simmered in coconut milk with aromatic curry leaves." },
      { name: "Delhi Royal Butter Chicken", desc: "Tandoori chicken in a velvety tomato butter sauce." },
      { name: "Mangalorean Ghee Roast Chicken", desc: "Fiery roasted chicken cooked in spiced ghee and tamarind." },
      { name: "North Malabar Mutton Rib Curry", desc: "Slow-braised mutton ribs in robust northern Kerala spices." },
      { name: "Kashmiri Slow-Braised Lamb Shank", desc: "Tender lamb shank slow-cooked with fragrant Kashmiri spices." },
      { name: "Black Pepper Kid Goat Fry", desc: "Tender goat stir-fried with crushed black pepper and warming spices." },
      { name: "Green Peppercorn Beef Ribs Pollichathu", desc: "Beef ribs roasted in banana leaf with green peppercorns and spices." },
      { name: "Thekkumkoor Coconut Beef Roast", desc: "Kerala-style beef roast with coconut, curry leaves and aromatic spices." },
    ],
  },
  {
    id: "rice-pilau",
    title: "Rice & Pilau",
    dishes: [
      { name: "Kerala Ghee Rice", desc: "Fragrant basmati rice enriched with aromatic Kerala ghee." },
      { name: "Coconut Rice", desc: "Steamed rice delicately infused with fresh coconut." },
      { name: "Saffron Pilau", desc: "Fragrant basmati rice scented with saffron and whole spices." },
      { name: "Goji Berry Pilau", desc: "Aromatic pilau rice with delicate sweetness from goji berries." },
      { name: "Lemon Rice", desc: "Fragrant rice tossed with fresh lemon and tempered spices." },
      { name: "Steamed Basmati", desc: "Light, fluffy basmati rice, simply steamed." },
      { name: "Kashmiri Vegetable Pilau", desc: "Fragrant basmati rice with seasonal vegetables and Kashmiri spices." },
    ],
  },
  {
    id: "biriyani",
    title: "Biriyani",
    dishes: [
      { name: "Malabar Beef Biriyani", desc: "Slow-cooked beef layered with fragrant basmati rice.", image: FOOD.biriyani, featured: true },
      { name: "Lucknow Lamb Biriyani", desc: "Awadhi-style lamb biryani with delicate aromatic spices." },
      { name: "Chicken Dum Biriyani", desc: "Fragrant basmati rice and tender chicken cooked together in a sealed pot." },
    ],
  },
  {
    id: "pairings",
    title: "Perfect Pairings",
    subtitle: "A marriage made in God's own country",
    dishes: [
      { name: "Puttu & Kottayam Fish Curry", desc: "Steamed coconut puttu paired with fiery Kottayam-style fish curry." },
      { name: "Alleppey Coastal Chicken Curry & Coconut Rice", desc: "Creamy coastal chicken curry served with fragrant coconut rice." },
      { name: "Dilli Royal Butter Chicken & Garlic Chilli Naan", desc: "Velvety butter chicken paired with warm garlic chilli naan." },
      { name: "Mangalorean Chicken Ghee Roast & Kerala Porotta", desc: "Fiery ghee-roasted chicken with flaky Kerala porotta." },
      { name: "Green Peppercorn Beef Ribs Pollichathu & Nool Porotta", desc: "Banana-leaf roasted beef ribs paired with delicate nool porotta." },
    ],
  },
  {
    id: "breads",
    title: "Breads",
    dishes: [
      { name: "Kerala Porotta", desc: "Flaky, layered flatbread with a crisp exterior and soft centre.", image: FOOD.breads, featured: true },
      { name: "Nool Porotta", desc: "Fine, delicate strands of layered Kerala flatbread." },
      { name: "Appam", desc: "Soft, lacy rice hoppers with a tender centre." },
      { name: "String Hoppers", desc: "Steamed rice noodles, delicate and light." },
      { name: "Malabar Rice Pathiri", desc: "Soft, thin rice flatbread from the Malabar coast." },
      { name: "Steamed Coconut Puttu", desc: "Steamed rice flour layered with fresh grated coconut." },
      { name: "Butter Naan", desc: "Soft tandoor-baked naan brushed with butter." },
      { name: "Garlic Naan", desc: "Tandoor-baked naan finished with fragrant garlic and butter." },
      { name: "Peshwari Naan", desc: "Sweet and aromatic naan filled with nuts and dried fruits." },
      { name: "Cheese Naan", desc: "Soft tandoori naan filled with melted cheese." },
      { name: "Keema Naan", desc: "Tandoor-baked naan filled with spiced minced meat." },
      { name: "MYON — Make Your Own Naan", desc: "Choose your favourite naan style and make it your own." },
    ],
  },
  {
    id: "vegetarian",
    title: "Vegetarian",
    dishes: [
      { name: "Kerala Avial", desc: "Seasonal vegetables cooked with coconut, yoghurt and traditional spices." },
      { name: "Grandma's Green Gram Curry", desc: "Slow-cooked green gram with coconut and warming spices." },
      { name: "Subz Handi", desc: "Seasonal vegetables simmered slowly in a traditional clay pot." },
      { name: "Vegetable Paal Curry", desc: "Seasonal vegetables in a delicate coconut milk sauce." },
      { name: "Cumin Baby Potatoes", desc: "Roasted baby potatoes tossed with cumin and aromatic herbs." },
      { name: "Jackfruit, Peas & Cashew Thoran", desc: "Stir-fried jackfruit with green peas, coconut and roasted cashews." },
      { name: "Paneer Butter Masala", desc: "Soft paneer in a rich tomato and butter gravy." },
      { name: "Garlic Spinach Dal", desc: "Creamy lentils and spinach tempered with fragrant garlic." },
      { name: "Punjabi Channa Masala", desc: "Punjabi-style chickpea curry with robust aromatic spices." },
      { name: "Pineapple Moru Curry", desc: "Kerala yoghurt curry balanced with sweet and tangy pineapple." },
    ],
  },
  {
    id: "indo-british",
    title: "Classic Indo-British Curries",
    dishes: [
      { name: "Korma", desc: "A mild, creamy curry with coconut, almonds and delicate warming spices." },
      { name: "Tikka Masala", desc: "Chargrilled meat in a rich tomato and cream sauce with aromatic spices." },
      { name: "Madras", desc: "A bold and fiery South Indian curry with chilli, garlic and tangy spices." },
      { name: "Jalfrezi", desc: "Medium-hot curry stir-fried with onions, peppers, tomatoes and green chillies." },
      { name: "Bhuna", desc: "A thick, intensely flavoured curry of slowly cooked spices, onions and tomatoes." },
      { name: "Balti", desc: "A medium-spiced curry with fresh tomatoes, onions and herbs, served in a steel balti dish." },
    ],
  },
  {
    id: "sharing",
    title: "Signature Sharing",
    groups: [
      {
        name: "Let's Meat",
        note: "The Malabar Grilleast — for two",
        dishes: [
          { name: "Tandoori Lamb Cutlets", desc: "Charred lamb cutlets seasoned with fragrant tandoori spices." },
          { name: "Kanthari Chicken", desc: "Tender chicken infused with fiery Kerala bird's-eye chilli." },
          { name: "Ajwain Prawns", desc: "King prawns marinated with delicate ajwain and aromatic spices." },
          { name: "Bone Marrow", desc: "Slow-roasted bone marrow served as a rich, indulgent accompaniment." },
          { name: "House Chutneys", desc: "A selection of freshly prepared house chutneys." },
        ],
      },
      {
        name: "Let's Dive",
        note: "Seafood platter",
        dishes: [
          { name: "Monkfish Tikka", desc: "Roasted monkfish with a fragrant curry leaf marinade." },
          { name: "Malabar Scallops", desc: "Seared scallops inspired by the flavours of the Malabar coast." },
          { name: "Kingfish Curry", desc: "King fish simmered in a tangy coconut coastal gravy." },
        ],
      },
    ],
  },
  {
    id: "dessert",
    title: "Dessert",
    dishes: [
      { name: "Mango Kulfi", desc: "Rich, creamy traditional kulfi infused with ripe mango.", image: FOOD.dessert, featured: true },
      { name: "Seasonal Sorbet Selection", desc: "Refreshing house sorbets inspired by the season's finest fruits." },
      { name: "Sweet Paan", desc: "A playful dessert inspired by the classic Indian paan." },
    ],
  },
];

export const TASTING = [
  {
    title: "Chef's 7-Course Tasting Menu",
    subtitle: "The Coastal Journey",
    note: "Wine pairing optional.",
    courses: [
      { name: "Kerala Snack Selection", desc: "A selection of traditional Kerala-inspired bites." },
      { name: "Green Garden Chaat", desc: "Kale, spinach and spring onions with yoghurt, tamarind and chaat spices." },
      { name: "Malabar Scallop", desc: "Delicately prepared scallop inspired by the flavours of the Malabar coast." },
      { name: "Curry Leaf Monkfish Tikka", desc: "Roasted monkfish with fragrant curry leaf marinade." },
      { name: "Mangalorean Ghee Roast Chicken", desc: "Fiery roasted chicken in spiced ghee and tamarind." },
      { name: "Kashmiri Lamb Shank with Saffron Pilau", desc: "Slow-braised lamb shank paired with fragrant saffron pilau." },
      { name: "Mango Kulfi", desc: "Creamy mango kulfi to finish." },
    ],
  },
  {
    title: "The Pan Indian Journey",
    subtitle: "A journey across the subcontinent",
    courses: [
      { name: "Pappad & Chutney Selection", desc: "Crisp pappad served with a selection of house chutneys." },
      { name: "Black Pepper Paneer Tikka", desc: "Tandoor-roasted paneer with mango and mint." },
      { name: "Kanthari Chicken Chop", desc: "Chicken chop marinated with fiery Kerala bird's-eye chilli." },
      { name: "Ajwain Cream Prawns", desc: "King prawns in a delicate ajwain cream marinade." },
      { name: "Delhi Butter Chicken with Garlic Naan", desc: "Tandoori chicken in a velvety tomato butter sauce with garlic naan." },
      { name: "Malabar Chicken Biriyani", desc: "Fragrant basmati rice layered with spiced chicken." },
      { name: "Sweet Paan Dessert", desc: "A refined dessert inspired by the flavours of traditional sweet paan." },
    ],
  },
];
